module.exports = __webpack_public_path__ + "media/images/aloe/icons/categories/sofa-d69aefb471b68bab61f122b051ca455a.svg";